import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Helpers from "../Config/Helpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import DataTable from "../Components/Datatable";
import filterBySearch from "../utils/filterBySearch";

function VehicleReceipts() {
  const navigate = useNavigate();
  const { vehicle_id, vehicle_name } = useParams();
  const [search, setSearch] = useState("");
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadReceipts = useCallback(() => {
    setLoading(true);
    axios
      .get(
        `${Helpers.baseUrl}/receipts/invoices/${Helpers.authParentId}`,
        Helpers.headers,
      )
      .then((response) => {
        const allReceipts = Array.isArray(response.data) ? response.data : [];
        const vehicleReceipts = allReceipts.filter((receipt) => {
          const id = receipt?.vehicle?._id || receipt?.vehicle;
          return String(id || "") === String(vehicle_id || "");
        });
        setReceipts(vehicleReceipts.reverse());
      })
      .catch((error) => {
        Helpers.unauthenticated(error, navigate);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [navigate, vehicle_id]);

  useEffect(() => {
    loadReceipts();
  }, [loadReceipts]);

  const filteredReceipts = filterBySearch(receipts, search, [
    (r) => r.customer?.name,
    (r) => r.vehicle?.make,
    (r) => r.vehicle?.model,
    (r) => r.totalPrice,
    (r) => r.paid,
    (r) => r.remaining,
    (r) => r.status,
  ]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Vehicle History</h4>
              <Link className="btn btn-light m-1" to="/user/vehicles">
                Back to Vehicles
              </Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body border-bottom">
                <div
                  className="row"
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <div className="col-9">
                    <h3>
                      <img
                        src={require("../images/icons/cars.png")}
                        alt="vehicle"
                        style={{ height: 36, marginRight: 10 }}
                      />
                      Receipts History: {decodeURIComponent(vehicle_name || "")}
                    </h3>
                  </div>
                  <div className="col-3">
                    <label>Search</label>
                    <input
                      className="form-control"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      disabled={loading}
                      placeholder={loading ? "Loading history..." : ""}
                    />
                  </div>
                </div>

                {loading ? (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-muted"
                    style={{ minHeight: 240 }}
                  >
                    <div
                      className="spinner-border text-primary mb-3"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div>Loading vehicle history...</div>
                  </div>
                ) : (
                  <DataTable
                    columns={[
                      "Sr. #",
                      "Date",
                      "Customer",
                      "Total",
                      "Paid",
                      "Remaining",
                      "Status",
                      "Actions",
                    ]}
                  >
                    {filteredReceipts.map((receipt, index) => (
                      <tr key={receipt._id}>
                        <td>{index + 1}</td>
                        <td>
                          {receipt.createdAt
                            ? new Date(receipt.createdAt).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{receipt.customer?.name || "-"}</td>
                        <td>$ {receipt.totalPrice || 0}</td>
                        <td>$ {receipt.paid || 0}</td>
                        <td>$ {receipt.remaining || 0}</td>
                        <td>{receipt.status || "-"}</td>
                        <td>
                          <Link
                            to={`/user/receipts/receipt-details/${receipt._id}`}
                            className="btn btn-success btn-sm"
                          >
                            <ion-icon name="eye-outline"></ion-icon>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </DataTable>
                )}

                {!loading && filteredReceipts.length === 0 ? (
                  <div className="text-center">
                    No receipts found for this vehicle
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VehicleReceipts;
